<template>
  <div class="flex blinki-input">
    <template v-if="textarea">
      <div class="full-width">
        <div class="flex blinki-input">
          <label class="blinki-textarea-label no-dhtmlx">{{label}}
            <span
              v-if="!optionnel"
              class="text-danger">(*)</span>
          </label>
        </div>
        <b-form-textarea
          :id="code"
          v-model="fieldLocal"
          class="blinki-input-txt full-width"
          required
          :placeholder="placeholder"
          rows="3"
          :disabled="disabled"
          max-rows="6">
        </b-form-textarea>
      </div>
    </template>
    <template v-else-if="select">
      <b-form-group :label-for="code" class="no-dhtmlx">
        <div>
          <label>{{label}}
            <span
              v-if="!optionnel || star"
              class="text-danger">(*)</span> </label>
        </div>
        <b-form-select
          @invalid=" $emit('invalid')"
          :id="code"
          class="blinki-input-txt"
          v-model="fieldLocal"
          :disabled="disabled"
          :options="options"
          :required="!optionnel"
        ></b-form-select>
      </b-form-group>
    </template>
    <template v-else-if="isPrice">
      <b-input-group append="€"
                    :label-for="code" class="ml-1 no-dhtmlx prix-group">
        <div>
          <label>{{label}}</label>
        </div>
        <b-form-input
          :id="code"
          type="number"
          v-model.number="fieldLocal"
          :state="state"
          :disabled="disabled"
          required
          step="0.01"
          min="0.00"
          @invalid=" $emit('invalid')"
          placeholder="Prix">
        </b-form-input>
      </b-input-group>
    </template>
    <template v-else-if="is_phone">
      <div class="ml-1 no-dhtmlx">
        <div>
          <label>Téléphone
            <span
              v-if="!optionnel"
              class="text-danger">(*)</span>
          </label>
        </div>
        <b-form-input type="text"
                      @invalid=" $emit('invalid')"
                      :state="state"
                      :required="!optionnel"
               class="blinki-input-txt"
                       v-model="fieldLocal" ></b-form-input>
      </div>
    </template>
    <template v-else-if="is_map">
      <div class="ml-1 no-dhtmlx">
        <div>
          <label>{{label}}
            <span
              v-if="!optionnel"
              class="text-danger">(*)</span>
          </label>
        </div>
        <b-form-input :id="module + '-' + id" type="text"
                      :state="state"
                      @invalid=" $emit('invalid')"
                      class="blinki-input-txt"
                      v-bind="getAttrs('is_map', mapMask)" v-model="fieldLocal" ></b-form-input>
        <b-tooltip placement="right" v-if="!state" :target="module + '-' + id" triggers="hover" variant="danger">
          Invalid <b>{{id}}</b> Format!
        </b-tooltip>
      </div>
    </template>
    <template v-else-if="is_price">
      <div class="ml-1 no-dhtmlx">
        <div>
          <label>
            {{label}}
            <span
              v-if="!optionnel"
              class="text-danger">(*)</span>
          </label>
        </div>
        <b-form-input type="number"
                      :min="1"
                      @invalid=" $emit('invalid')"
                      class="blinki-input-txt"
                      :state="state"
                      step="0.1"
                      :required="!optionnel"
                      :disabled="disabled"
                      v-bind="getAttrs('price', priceMask)" v-model="fieldLocal" ></b-form-input>
      </div>
    </template>
    <template v-else-if="type === 'contenance'">
      <div class="ml-1 no-dhtmlx">
        <div>
          <label>
            {{label}}
            <span
              v-if="!optionnel"
              class="text-danger">(*)</span>
          </label>
        </div>
        <b-form-input type="text"
                      @invalid="$emit('invalid')"
                      class="blinki-input-txt"
                      :state="state"
                      :required="!optionnel"
                      :disabled="disabled"
                      v-bind="getAttrs('contenance', contenanceMask)" v-model="fieldLocal" ></b-form-input>
      </div>
    </template>
    <template v-else-if="isAlphabet">
      <div class="ml-1 no-dhtmlx">
        <div>
          <label>
            {{label}}
            <span
              v-if="!optionnel"
              class="text-danger">(*)</span>
          </label>
        </div>
        <b-form-input type="text"
                      @invalid=" $emit('invalid')"
                      :state="state"
                      :disabled="disabled"
                      class="blinki-input-txt"
                      :required="!optionnel"
                      v-mask="'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX'" v-model="fieldLocal" ></b-form-input>
      </div>
    </template>
    <template v-else-if="isEmail">
      <div class="ml-1 no-dhtmlx">
        <div>
          <label>
            {{label}}
            <span
              v-if="!optionnel"
              class="text-danger">(*)</span>
            <span class="text-danger" v-if="show_error">
              (entrez une adresse mail valide)
            </span>
          </label>
        </div>
        <b-form-input type="email"
                      @invalid=" $emit('invalid')"
                      :disabled="disabled"
                      :required="!optionnel"
                      class="blinki-input-txt"
                      v-mask="'EEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEE'"
                      v-model="fieldLocal" ></b-form-input>
      </div>
    </template>
    <template v-else-if="is_duree">
      <div class="ml-1 no-dhtmlx">
        <div>
          <label>{{label}}
            <span
              v-if="!optionnel"
              class="text-danger">(*)</span>
          </label>
        </div>
        <b-form-input
                      @invalid=" $emit('invalid')"
                      min="5"
                      step="1"
                      max="240"
                      type="number"
                      :required="!optionnel"
                      :disabled="disabled"
                      class="blinki-input-txt"
                      v-model="fieldLocal" ></b-form-input>
      </div>
    </template>
    <template v-else-if="is_date">
      <div class="ml-1 no-dhtmlx">
        <div>
          <label>{{label}}
          </label>
        </div>
        <b-form-datepicker :id="id" v-model="fieldLocal"
                           :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                           locale="fr"
                           :min="min"
                           :max="max"
                           :required="!optionnel"
                           :disabled="disabled"
                           placeholder=""
                           class="blinki-input-txt"
                           ></b-form-datepicker>

      </div>
    </template>
    <template v-else>
      <b-form-group :label-for="code" class="ml-1 no-dhtmlx">
        <div>
          <label>{{label}}
            <span
              v-if="!optionnel"
              class="text-danger">(*)</span> </label>
        </div>
        <b-form-input
          :id="code"
          class="blinki-input-txt"
          @invalid=" $emit('invalid')"
          :type="localType"
          v-model="fieldLocal"
          :max="Localmax"
          :min="Localmin"
          :state="state"
          :required="!optionnel"
          :disabled="disabled"
          :step="LocalStep"
          :placeholder="placeholder">
        </b-form-input>
      </b-form-group>
    </template>
  </div>
</template>

<script>
  import createNumberMask from 'text-mask-addons/dist/createNumberMask'
  import emailMask from 'text-mask-addons/dist/emailMask'
  const numberMask = createNumberMask({
    prefix: '',
  });
  const priceMask = createNumberMask({
    prefix: '',
    suffix: '',
    allowDecimal: true,
    thousandsSeparatorSymbol:'',
  });
  const contenanceMask = createNumberMask({
    prefix: '',
    allowDecimal: true,
    suffix: '',
    minValue: 0,
  });
  const mapMask = createNumberMask({
    prefix: '',
    allowDecimal: true,
    suffix: '',
    decimalLimit:20,
    allowNegative:true,
    thousandsSeparatorSymbol:''
  });
  export default {
    name: "blinki-input-txt",
    props: ['value',
      'module',
      'id',
      'placeholder',
      'disabled',
      'label',
      'state',
      'select',
      'options',
      'no_icon',
      'is_duree',
      'is_date',
      'star',
      'is_price',
      'textarea',
      'max',
      'min',
      'optionnel',
      'is_phone',
      'show_error',
      'is_map',
      'type',
      'step',
      'disabled',
      'applyMask',
    ],
    data(){
      return {
        numberOfDigits:[],
        numberMask:numberMask,
        mapMask:mapMask,
        emailMask:emailMask,
        priceMask:priceMask,
        contenanceMask: contenanceMask
      }
    },
    methods: {
      isValid(value) {
        this.$emit('is_valid', value)
      },
      // Fix for v-mask not changing value of input (related to : popups/produits/add, template/products/variantItem.vue, Context : DraftToggle)
      getAttrs(name, mask) {
        if(name === 'price') {
          if(this.applyMask) {
            return { 'v-mask': mask };
          }
        }
      }
    },
    computed: {
      isPrice(){
        return this.type ? this.type === "prix" : false
      },
      isEmail(){
        return this.type ? this.type === "email" : false
      },
      isAlphabet(){
        return this.type ? this.type === "alphabet" : false
      },
      /**
       * @return {boolean}
       */

      fieldLocal: {
        get: function () {
          return this.value
        },
        set: function (value) {
          this.$emit('input', value)
        }
      },
      code() {
        return this.module + '-' + this.id
      },
      localType(){
        return this.type ? this.type  : 'text';
      },
      Localmax(){
        return this.max ? this.max  : null;
      },
      LocalStep(){
        return this.step ? this.step : 1;
      },
      Localmin(){
        return this.min ? this.min  : null;
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~/assets/css/theme.scss';
  .prix.b-icon {
    top: 12px;
  }
  .input-group.prix-group .form-control{
    border-left: 1px solid $secondary-color;
  }
  /deep/ .custom-select:disabled {
    background : #ffffff00;
  }
</style>
